<template>
    <Drawer :direction="'right'" :set-background-color-on-scale="false">
        <div class="flex justify-between items-center p-4 px-8 rounded-3xl" :class="{'bg-primary text-white': !white, 'bg-white text-black': white}">
            <div class="flex items-center gap-4">
                <a href="/" class="font-bold text-lg">
                    <img :src="logo" :alt="'Logo'" class="h-8 inline"/>
                </a>
<!--                <Breadcrumbs></Breadcrumbs>-->
            </div>


            <DrawerTrigger class="cursor-pointer" :alt="$t('Åpne meny')">
                <Menu class="font-bold" />
            </DrawerTrigger>
        </div>

        <DrawerContent :class="'rounded-l-xl  bg-zinc-50'">
            <DrawerHeader>
                <DrawerTitle class="mx-8 my-4 text-xl">
                    <div class="flex justify-between">
                        <a href="/" class="font-bold text-lg">
                            <img :src="logo" :alt="site.officeName" class="h-8 inline"/>
                        </a>
                        <DrawerClose class="w-[34px] h-[34px] flex items-center justify-center rounded-3xl cursor-pointer transition-all bg-white shadow scale-100 hover:scale-110 hover:bg-primary hover:text-white">
                            <X :size="24" />
                        </DrawerClose>
                    </div>
                </DrawerTitle>
                <DrawerDescription :class="'mt-4'">
                    <a v-for="item in menuItems" :key="'nav-item-' + item.id"
                          :href="item.item_link"
                         class="block first:rounded-t-xl last:rounded-b-xl font-light px-8 py-4 w-[100%] bg-white text-black cursor-pointer text-xl shadow-sm hover:shadow hover:bg-primary hover:text-white">
                            {{ item.item_name }}
                    </a>
                </DrawerDescription>
            </DrawerHeader>
        </DrawerContent>
    </Drawer>
</template>

<script setup>
    import { ref } from 'vue'
    import {
        Drawer,
        DrawerContent,
        DrawerDescription,
        DrawerHeader,
        DrawerTitle,
        DrawerTrigger,
        DrawerClose,
    } from '@/components/ui/drawer'

    import { Menu, X } from 'lucide-vue-next'
    import Breadcrumbs from 'p3/components/navigation/Breadcrumbs.vue'
    import axios       from "axios";

    defineProps({
        white: {
            type: Boolean,
            default: false
        },
        logo: {
            type: String,
            default: ''
        },
    })

    const menuItems = ref([])
    const site = ref({...window.site});



    axios.get('/api/v2/navigation', {
        params: {
            officeId: window.officeId,
            preview: false,
        },
    }).then(res => {
        menuItems.value = res.data.items

    }).catch(err => {
        console.error(err)
    })





</script>